import { TextField, Tooltip } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import '../../../scss/Components/_modal.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalTitle(props) {
  const [titleText, setTitleText] = useState('');
  const [columns, setColumns] = useState(1);

  const {
    questionModalTitleString,
    questionModalTTextString,
    questionModalTColumnsString,
    questionModalTColumnsTooltip,
    saveString,
  } = useTranslationHook();

  function hide() {
    props.onHide();
    getToast({ status: 'success', title: 'Título creado exitosamente en el cuestionario.' });
    props.getQuestionsData(props.selectedSection);
    props.getDirectoryData();
  }

  function createTitle(event) {
    event.preventDefault();
    customAxios
      .post(
        `${GlobalVariables.getURL()}createSection/${props.selectedSection}`,
        {
          title: titleText,
					num_columns: columns,
          questionnaire_id: props.selectedQuestionnaire,
        }, {
          headers: {
            'Authorization': 'bearer ' + localStorage.getItem('token')
          }
        }
      )
      .then(
        (response) => {
          console.log(response.data);
          hide();
        },
        (error) => {
          console.log(error);
          getToast({ status: 'error', title: 'Error al crear título. Vuelve a intentarlo.' });
        }
      );
  }

  return (
    <Modal
      {...props}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          {questionModalTitleString}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id='add-title-form' onSubmit={createTitle}>
          <div className='row'>
            <div className='col-md-9'>
              <TextField
                sx={{ width: '100%' }}
                label={questionModalTTextString}
                type='text'
                value={titleText}
                onChange={(e) => setTitleText(e.target.value)}
                required
              />
            </div>
            <div className='col-md-3'>
              <Tooltip
                title={questionModalTColumnsTooltip}
                placement='top'
                arrow
              >
                <TextField
                  sx={{ width: '100%' }}
                  label={questionModalTColumnsString}
                  type='number'
                  value={columns}
                  onChange={(e) => setColumns(e.target.value)}
                  required
                />
              </Tooltip>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          form='add-title-form'
          type='submit'
          className='save-modal-button'
        >
          {saveString}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalTitle;
